import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';
import { AsyncPageRender } from '../../../Components/AsyncComponent';
import { ProtectedRoute } from '../../../Components/Layout/ProtectedRoute';
import { routes$ as sales$ } from '../Sales/Router';

export const routes$ = {
    View: AsyncPageRender(() => pageModule(import('./View'))),
};

function Router() {
    return (
        <>
            <Route exact path={'/finance/sales-ledger'} component={ProtectedRoute(sales$.Ledger)} />
            <Route exact path={'/finance/reports'} component={ProtectedRoute(routes$.View)} />
            <Route exact path={'/finance/salesmen-reports'} component={ProtectedRoute(sales$.Finance)} />

            <Route exact path={'/finance/salesmen/list/:tab'} component={ProtectedRoute(sales$.List)} />
            <Route exact path={'/finance/salesmen/:salesman'} component={ProtectedRoute(sales$.View)} />
            <Route exact path={'/finance/salesmen/:salesman/edit'} component={ProtectedRoute(sales$.Edit)} />
        </>
    );
}

export default Router;
